import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (this.element.dataset.modalContentUrl) {
      $(this.element).on("show.bs.modal", async () => {
        const content = await this.loadContent(this.element.dataset.modalContentUrl);
        this.setContent(content);
      });
    }

    $(this.element).on("hidden.bs.modal", () => {
      this.element.remove();
    });

    $(this.element).on("close.modal", (e, callback) => {
      $(this.element).on("hidden.bs.modal", callback);
      $(this.element).modal("hide");
    });
    
    $(this.element).modal("show");
  }

  async loadContent(url) {
    return await fetch(url)
      .then(response => response.text())
      .then(html => { return html; });
  }

  setContent(content) {
    this.element.querySelector(".modal-content").innerHTML = content;
  }

  close() {
    $(this.element).modal("hide");
  }
}
